/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import translate from "@insite/client-framework/Translate";
import SignInResetPasswordForm from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import React from "react";

interface OwnProps {
    isResetPasswordModalOpen: boolean;
    onResetPasswordClose: () => void;
}

export interface ResetPasswordModalStyles {
    resetPasswordModal?: ModalPresentationProps;
}

export const resetPasswordModalStyles: ResetPasswordModalStyles = {
    resetPasswordModal: {
        size: 450,
    },
};

const styles = resetPasswordModalStyles;

const ResetPasswordModal = ({ isResetPasswordModalOpen, onResetPasswordClose }: OwnProps) => {
    return (
        <Modal
            headline={translate("Reset Password")}
            {...styles.resetPasswordModal}
            isOpen={isResetPasswordModalOpen}
            handleClose={() => onResetPasswordClose()}
        >
            <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
        </Modal>
    );
};

export default ResetPasswordModal;
